module.exports = __webpack_public_path__ + "img/SWP_Shield_09 (2).ddefdfed.png";